import axios from 'axios';

export function fetch(options) {
    return new Promise((resolve, reject) => {
        const instance = axios.create({
            headers: {
                'Content-Type': 'application/json',
                // 'authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJqdGkiOiI2ZDQ4MjUwZWRmMTg0YmI4ODY4ZDQzYzU5ZjhlYWFhZiIsInVzZXIiOiJhZG1pbjEiLCJzdWIiOiJhZG1pbjEifQ.W1RArzK8_NN-4_c6AAXohIIHpDT724JtSFhgyrxnmh8s7CsgbiVCDOPmF-kN3_PhRkoTj90VmikHMkjuRw8tcA',
            },
            //withCredentials: true,  //表示跨域请求时是否需要使用凭证
            crossDomain: true,      //允许跨域
            // timeout: 10 * 1000 // 10秒超时

        });
        instance(options)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                console.log('error' + error);
                // if(error.response.status == 504){
                //     Router.replace("/error");
                // }
                reject(error);
            });
    });
}
